import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { storeStartLoading } from '../../actions/storeCrud';
import { filterStock } from '../../actions/stock';
import { filterDeliveryDonwload } from '../../actions/deliveryNotes';
import { filterDeliveryDonwloadN } from '../../actions/deliveryNotes';
import { filterDeliveryExpedition } from '../../actions/deliveryNotes';
import { filterSscc } from '../../actions/sscc';
import { filterCmp } from '../../actions/cmp';
import { userStartLoading } from '../../actions/userCrud';
import { filterMovement } from '../../actions/movement';

export const BtnReload = ({props, data}) => {

    const dispatch = useDispatch();
    const { store } = useSelector(state => state.auth);

    const handleClick = () => {

        switch (props) {
            case 'store':
                dispatch(storeStartLoading());
                break;
            case 'user':
                dispatch(userStartLoading());
                break;
            case 'movement':
                dispatch(filterMovement(data));
                break;
            case 'delivery':
                dispatch(filterDeliveryDonwload(data));
                break;
            case 'deliveryN':
                dispatch(filterDeliveryDonwloadN(data));
                break;
            case 'deliveryE':
                dispatch(filterDeliveryExpedition(data));
                break;
            case 'ssccData':
                dispatch(filterSscc(data));
                break;
            case 'cmpData':
                dispatch(filterCmp(data));
                break;
            default:
                dispatch(filterStock(data));
                break;
        }
    }

    return (
        <button className="btn btn-danger btn-color" props={props} onClick={handleClick}>
            <ReloadOutlined/>
        </button>
    )
}
